module.exports = __webpack_public_path__ + "static/media/stan.fb57d4c2.png";